import React, { Component } from 'react';
import PropTypes from 'prop-types';
import strings from '../locales/';
import utilFunction from '../../containers/function';
import constants from '../../containers/function/constants';

class TodayReportsTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    var rows = [];    
    var i = 0;
    var tableTotal = 0;
    var rowsLimit = 18;
    var timeFormatFunction = utilFunction.getFormatFunction(
              {type:"DATE_TIME_PARSE_ISO_GAUSS",format:"%H:%M"});
    var dateFormatFunction1 = utilFunction.getFormatFunction(
              {type:"DATE_TIME_PARSE_ISO_GAUSS",format:"%d de "});
    var dateFormatFunction2 = utilFunction.getFormatFunction(
              {type:"DATE_TIME_PARSE_ISO_GAUSS",format:"%B"});
    var dateFormatFunction3 = utilFunction.getFormatFunction(
              {type:"DATE_TIME_PARSE_ISO_GAUSS",format:" de %Y"});

    var statsList = this.props.data.statsList;
    var timeLabel = "Horario (" + timeFormatFunction(this.props.data.fromDate) +
        " a " + timeFormatFunction(this.props.data.toDate) + ")";
    var trucksNumberProperty = 
        "flowRequests" + this.props.usedDirection + "Number";
    var mopNumberProperty = 
        "flowRequests" + this.props.usedDirection + "NumberMop";
    
    var monthName = dateFormatFunction2(this.props.data.fromDate).toLowerCase();
    var monthNameTranslate = this.props.language.flows.months[monthName] ?
      this.props.language.flows.months[monthName] : 
      monthName;
    
    var title = this.props.usedDirectionLabel + ", " + 
      dateFormatFunction1(this.props.data.fromDate).toLowerCase() + 
      monthNameTranslate + 
      dateFormatFunction3(this.props.data.fromDate).toLowerCase();

    while(i<rowsLimit) {
      if(statsList[i] && statsList[i][trucksNumberProperty]>0) {
        rows.push([
          statsList[i]["filterTags"],
          statsList[i][trucksNumberProperty],
          timeFormatFunction(statsList[i]["dateTime"]),
          statsList[i][mopNumberProperty]
        ]);
        tableTotal+=statsList[i][trucksNumberProperty];
      }
      else if(statsList[i] && statsList[i][trucksNumberProperty]==0) {
        rowsLimit++; 
      }
      else {
        rows.push(["","","",""]);       
      }      
      i++;
    }

    return (
    	<section className="today-reports-table">
        <div className="today-reports-table-title">
          {title}
        </div>
        <table>
          <thead>
            <tr>
              <th className="today-reports-table-th carrier-th">{"Transportista"}</th>
              <th className="today-reports-table-th truck-number-th">{"N Camiones"}</th>
              <th className="today-reports-table-th time-th">{timeLabel}</th>
              <th className="today-reports-table-th mop-th">{"MOP"}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((item, i)=>(
              <tr key={`t-today-reports-table-${i}`}>
                <td className="today-reports-table-td carrier-td">{rows[i][0]}</td>
                <td className="today-reports-table-td truck-number-td">{rows[i][1]}</td>
                <td className="today-reports-table-td time-td">{rows[i][2]}</td>
                <td className="today-reports-table-td mop-td">{rows[i][3]}</td>
              </tr> 
            ))}
            <tr>
              <td className="today-reports-table-td-total total-title-td">{"Total"}</td>
              <td className="today-reports-table-td-total total-number-td">{tableTotal}</td>
              <td className="today-reports-table-td-total total-empty-td" colSpan="2"></td>
            </tr>
          </tbody>
        </table>
      </section>
    );
  }
}

export default TodayReportsTable;



// WEBPACK FOOTER //
// ./source/client/components/flow_admin_detail/todayReportsTable.jsx